/**
 * Enum for External Payment Status
 * @readonly
 * @enum {string}
 */
let ExternalPaymentStatusEnum = {
    CANCELED:   "CANCELED",
    DECLINED:   "DECLINED",
    ERROR:      "ERROR",
    PENDING:    "PENDING",
    PROCESSING: "PROCESSING",
    SUCCESS:    "SUCCESS"
};

export default ExternalPaymentStatusEnum;
